import styled from 'styled-components';
import { SelectInput } from '@thinknet-gmbh/platform-common-ui';

export const SalaryTypesWrapper = styled.div`
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
`;

export const ClientsSelectStyledInput = styled(SelectInput)`
  .ant-select-selection-overflow {
    .ant-select-selection-overflow-item {
      margin-right: 5px;
      ::after {
        content: ',';
      }

      :nth-last-child(-n + 2) {
        margin-right: 0;
        ::after {
          content: '';
        }
      }
    }
  }
  .ant-checkbox-wrapper {
    margin-right: 9px;
  }
`;
